import { IconButton, useTheme } from "@mui/material";
import { Ellipsis } from "lucide-react";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ActivityBasicInfoSection } from "web_myplann/Activities/Components/ActivityBasicInfoSection";
import { ActivityNotesSection } from "web_myplann/Activities/Components/ActivityNotesSection";
import { ActivityParticipantsSection } from "web_myplann/Activities/Components/ActivityParticipantsSection";
import { useActivityDetail } from "web_myplann/Activities/Hooks/useActivityDetail";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailSectionLoader } from "web_myplann/Portfolio/Components/DetailSectionLoader";
import { ContactDrawer } from "web_myplann/Shared/Components/ContactDrawer";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { getBackFallbackRoute } from "web_myplann/Shared/Utils/backNavigation";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";

const R = Resources.Activity.Detail;

export const ActivityDetailV2Page = () => {
	const routeParams = useParams<{ id: string }>();
	const activityId = getTypedParam(routeParams, "id", Number) ?? null;
	const theme = useTheme();
	const { t } = useResource();
	const location = useLocation();

	const [contactOpen, setContactOpen] = useState(false);

	const {
		event,
		notes,
		participantGroups,
		hasMoreAgents,
		isLoading,
		contactPhone,
		contactEmail,
	} = useActivityDetail(activityId);

	if (activityId === null) return null;

	return (
		<>
			<MyPlannLayout
				disableContentPadding
				bgColor={theme.palette.surface.muted}
				topBar={
					<MyPlannNavigationHeader
						title={t(R.title)}
						bgColor={theme.palette.background.paper}
						defaultRoute={getBackFallbackRoute(location.pathname)}
						replaceOnBack
						endComponent={
							<IconButton variant="ghost" onClick={() => setContactOpen(true)}>
								<Ellipsis
									size={theme.iconSize.md}
									color={theme.palette.grey[700]}
								/>
							</IconButton>
						}
					/>
				}
			>
				{isLoading ? (
					<DetailSectionLoader />
				) : (
					event && (
						<>
							<ActivityBasicInfoSection
								event={event}
								hasMoreAgents={hasMoreAgents}
							/>
							<ActivityParticipantsSection groups={participantGroups} />
							<ActivityNotesSection notes={notes} />
						</>
					)
				)}
			</MyPlannLayout>
			<ContactDrawer
				open={contactOpen}
				onClose={() => setContactOpen(false)}
				phone={contactPhone}
				email={contactEmail}
			/>
		</>
	);
};
